<template>
  <div class="video-section section-content"
       data-aos="fade"
       data-aos-duration="2000">
    <div class="video-container">
      <div class="video-container__placeholder-container"
           v-if="!playingVideo">
        <div class="video-container__placeholder-photo">
          <img src="../../assets/hero-home.jpg" alt="The Value of Your Voice"/>
        </div>
        <div class="video-container__placeholder-overlay">
          <div class="grid-container">
            <div class="grid-x">
              <div class="overlay-text cell large-8 large-offset-2 text-center"
                   data-aos="fade-left"
                   data-aos-duration="600">
                <h1 class="overlay-text__header">The Value of Your Voice</h1>
                <h4 class="overlay-text__subheader">2019 SVMIC Annual Report</h4>
                <div class="overlay-text__play"
                     @click="playVideo">
                  <div class="overlay-text__play-button">
                    <FontAwesomeIcon icon="play" />
                  </div>
                  <p class="overlay-text__play-text">
                    Watch the Video
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main-video-content"
           :class="{'inactive' : !playingVideo}">
        <div class="main-video-content__video">
          <vueVimeoPlayer ref="player"
                          video-id="397456143"
                          video-url="https://vimeo.com/397456143/6a4eabcc6b"
                          :options="{ responsive: true }"
                          @pause="onPause"
                          class="vimeo-player"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { vueVimeoPlayer } from 'vue-vimeo-player';

export default {
  name: 'HomeHeroVideo',
  components: { vueVimeoPlayer },
  data: function () {
    return {
      playingVideo: false
    };
  },
  methods: {
    playVideo: function () {
      this.playingVideo = true;
      this.$refs.player.play();
      /* eslint-disable */
      $(".vimeo-player iframe").css("max-height", "80vh");
      $(".board-chair *[data-aos]").addClass("aos-animate");
      /* eslint-enable */
    },
    onPause: function () {
      this.playingVideo = false;
      /* eslint-disable */
      $(".board-chair *[data-aos]").removeClass("aos-animate");
      /* eslint-enable */
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../styles/setup/variables";

  .video-section {
    cursor: default;
    margin: 0;
    padding: 0;
    max-height: 80vh;

    .video-container {
      background-color: $black;
      position: relative;

      .video-container__placeholder-container {
        width: 100%;

        .video-container__placeholder-photo {
          background-color: #FFFFFF;
          img {
            object-fit: cover;
            max-width: unset;
            width: 100%;
            height: 80vh;
          }
        }

        .video-container__placeholder-overlay {
          height: 100%;
          width: 100%;
          left: 0;
          position: absolute;
          top: 0;

          .overlay-text {
            color: $purp;
            height: 100%;
            position: relative;
            z-index: 1;
            text-align: left;
            margin-top: 50vh;

            @include breakpoint(small only) {
              padding-right: 10px;
            }

            .overlay-text__header {
              margin: 0;
            }

            .overlay-text__subheader { // Responsiveness in action
              font-family: $sans-serif;
              font-weight: $sans-serif-weight;
              letter-spacing: 3px;
              text-transform: uppercase;
              margin: 0 0 2vh;
              display: inline-block;
              width: 100%;
            }

            .overlay-text__play {
              display: flex;
              cursor: pointer;
              &:hover {
                .overlay-text__play-button {
                  background: $purp;
                }
              }
            }

            $play-button-blue: #55CAEF;
            .overlay-text__play-button {
              transition: 400ms ease-in-out;
              color: white;
              background-color: $play-button-blue;
              padding: 0 20px;
              line-height: 54px;
            }

            .overlay-text__play-text { // Watch the video
              transition: 400ms ease-in-out;
              line-height: 54px;
              height: 54px;
              padding: 0 40px;
              background-color: white;
              color: $purp;
              font-family: $sans-serif;
              font-weight: 800;
              font-size: 12px;
              letter-spacing: 2px;
              margin: 0;
              text-transform: uppercase;
            }

            @include breakpoint(small only) {
              text-align: right;
              .overlay-text__header {
                font-size: 6vw;
              }
              .overlay-text__subheader {
                font-size: 2.8vw;
              }
              .overlay-text__play {
                display: inline-block;
                .overlay-text__play-button {
                  vertical-align: middle;
                  display: inline-block;
                }
                .overlay-text__play-text {
                  font-size: 11px;
                  display: inline-block;
                }
              }
            }

            @include breakpoint(medium only) {
              left: 46%;
              .overlay-text__header {
                font-size: 4.8vw;
              }
              .overlay-text__subheader {
                font-size: 2vw;
              }
            }

            @include breakpoint(large) {
              left: 32%;
              .overlay-text__header {
                font-size: 4.2vw;
              }
              .overlay-text__subheader {
                font-size: 1.6vw;
              }
            }
            @include breakpoint(xlarge) {
              left: 34%;
              .overlay-text__header {
                font-size: 4vw;
              }
              .overlay-text__subheader {
                font-size: 1.4vw;
              }
            }
            @include breakpoint(xxlarge) {
              left: 38%;
              .overlay-text__header {
                font-size: 3vw;
              }
              .overlay-text__subheader {
                font-size: 0.8vw;
              }
            }
          }
        }
      }

      .main-video-content {
        transition: opacity 500ms;
        &.inactive {
          opacity: 0;
        }
      }
    }
  }
</style>
